// src/contexts/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Check if user is logged in on app start
        const token = sessionStorage.getItem("accessToken");
        const userEmail = sessionStorage.getItem("userEmail");
        const userRole = sessionStorage.getItem("userRole");

        if (token && userEmail) {
            setUser({
                email: userEmail,
                role: userRole || 'user'
            });
        }
        setLoading(false);
    }, []);

    const login = (email, role) => {
        const userData = { email, role };
        setUser(userData);
        sessionStorage.setItem("userEmail", email);
        sessionStorage.setItem("userRole", role);
    };

    const logout = () => {
        setUser(null);
        sessionStorage.removeItem("accessToken");
        sessionStorage.removeItem("userEmail");
        sessionStorage.removeItem("userRole");
    };

    const isAdmin = () => {
        return user?.email === 'admin@example.com';
    };

    const value = {
        user,
        login,
        logout,
        isAdmin,
        loading
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};